import { api } from "api/api";
import { AxiosError } from "axios";
import FamiliaProduto from "model/administracao/cadastro/produto/FamiliaProduto";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import DescarteInutilizavel from "model/patrimonio/DescarteInutilizavel";
import Deposito from "model/suprimentos/Deposito";
import EstoqueLote from "model/suprimentos/EstoqueLote";
import TransferenciaEstoque from "model/suprimentos/TransferenciaEstoque";
import { DataTableFilterMeta } from "primereact/datatable";
import { getFilters } from "utils/filterUtils";

class EstoqueInutilizavelService {

    pesquisar(page: Pageable, filters: DataTableFilterMeta) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/estoqueInutilizavel/pesquisar`;
            url += getFilters(filters)
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    ativarDesativar(estoqueLote: EstoqueLote){
        return new Promise<void>((resolve, reject): void => {
            let url = `/estoqueInutilizavel/ativarDesativar`;

            api
                .put(url, JSON.stringify(estoqueLote))
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    familias() {
        return new Promise<Array<FamiliaProduto>>((resolve, reject): void => {
            api
                .get(`/estoqueInutilizavel/familias`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    origens() {
        return new Promise<Array<OrigemProduto>>((resolve, reject): void => {
            api
                .get(`/estoqueInutilizavel/origens`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/estoqueInutilizavel/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getDepositos() {
        return new Promise<Array<Deposito>>((resolve, reject): void => {
            api
                .get(`/estoqueInutilizavel/depositos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutosDisponiveis(deposito: Deposito) {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`/estoqueInutilizavel/produtosDisponiveis/${deposito.codigo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getLotesDisponiveis(deposito: Deposito, produto: Produto) {
        return new Promise<Array<string>>((resolve, reject): void => {
            api
                .get(`/estoqueInutilizavel/lotesDisponiveis/${deposito.codigo}/${produto.codigo}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    descartar(descarteInutilizavel: DescarteInutilizavel) {
        return new Promise<Array<void>>((resolve, reject): void => {
            api
                .put(`/estoqueInutilizavel/descartar`, JSON.stringify(descarteInutilizavel))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    recuperar(descarteInutilizavel: DescarteInutilizavel) {
        return new Promise<Array<void>>((resolve, reject): void => {
            api
                .put(`/estoqueInutilizavel/recuperar`, JSON.stringify(descarteInutilizavel))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    transferir(transferenciaEstoque: TransferenciaEstoque) {
        return new Promise<Array<void>>((resolve, reject): void => {
            api
                .put(`/estoqueInutilizavel/transferir`, JSON.stringify(transferenciaEstoque))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default EstoqueInutilizavelService;
